import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CloseIcon, CheckboxAll } from 'components';
import { 
    Typography,
    Divider,
    Grid,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button
} from "@material-ui/core";
import { actions } from 'store/unSubscribe';
import UserMessageSnackbar from 'views/UserMessaging/customModalContent/userMessageSnackbar';

const { updateResubscribe } = actions;

const useStyles = makeStyles(theme => ({
    root: {},
    headerContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between'
    },
    cardActions: {
        flexDirection: 'row-reverse'
    },
    options: {
        minHeight: '60vh',
        display: 'flex',
        justifyContent: 'space-around',
        overflowY: 'auto'
    },
    sections: {
        margin: '0px 16px'
    },
    submitButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));

const Edit = props => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const currentEdit = useSelector(store => store.unSubscribe.currentEdit);
    const isLoading = useSelector(store => store.unSubscribe.updating);
    const isResubscribeSaved = useSelector(store => store.unSubscribe.lastUpdateStatus);
    const campaignsList = useSelector(store => store.campaign.allCampaignsList);

    const [promotionalData, setPromotionalData] = useState([]);
    const [transactionalData, setTransactionalData] = useState([]);
    const [allPromotionalCampaigns, setAllPromotionalCampaigns] = useState(currentEdit.allPromotionalCampaigns);
    const [allTransactionalCampaigns, setAllTransactionalCampaigns] = useState(currentEdit.allTransactionalCampaigns);

    useEffect(() => {
        if (Object.keys(currentEdit).length === 0) {
            history.push('/unsubscribe');
        }
        setPromotionalData(campaignsList.filter(option => option.promotional).map(option => {
          let checked = [...new Array(...currentEdit?.campaignUuids)].includes(option.uuid) ? true : false;
          return {
            ...option,
            checked: checked || currentEdit.allPromotionalCampaigns,
            disabled: !checked
          };
        }).sort((a, b) => a.name.localeCompare(b.name)));
        setTransactionalData(campaignsList.filter(option => !option.promotional).map(option => {
          let checked = [...new Array(...currentEdit?.campaignUuids)].includes(option.uuid) ? true : false;
          return {
            ...option,
            checked: checked || currentEdit.allTransactionalCampaigns,
            disabled: !checked
          };
        }).sort((a, b) => a.name.localeCompare(b.name)));
    }, [])

    const submitPreference = () => {
        let allPromotionalCampaignsEnabled = promotionalData.every(option => option.checked) || allPromotionalCampaigns;
        let allTransactionalCampaignsEnabled = transactionalData.every(option => option.checked) || allTransactionalCampaigns;
        let campaignUuid = [];
        if (!allPromotionalCampaignsEnabled) {
          campaignUuid = [...campaignUuid, ...promotionalData]
        }
        if (!allTransactionalCampaignsEnabled) {
          campaignUuid = [...campaignUuid, ...transactionalData]
        }
        let updatedResubscribeData = {
          tenantId: currentEdit.tenantId,
          businessContextId: currentEdit.businessContextId,
          emailAddress: currentEdit.emailAddress,
          allPromotionalCampaigns: allPromotionalCampaignsEnabled,
          allTransactionalCampaigns: allTransactionalCampaignsEnabled,
          campaignUuids: campaignUuid.filter(option => !option.checked && !option.disabled).map(option => option.uuid)
        }
        dispatch(updateResubscribe(updatedResubscribeData));
    };

    const closeTemplate = () => {
        history.push('/unsubscribe');
    };

    return (
        <div className={classes.root}>
            <Card>
                <div className={classes.headerContainer}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <CardHeader
                        title="Unsubscribed Campaigns"
                        titleTypographyProps={{ variant: 'h2' }}
                        />
                    </div>
                    <CloseIcon onClickClose={closeTemplate} />
                </div>
                <Divider />
                <CardContent>
                    {(Object.keys(currentEdit).length > 0) && (
                        <div className={classes.options}>
                            <div className={classes.sections}>
                                <Typography variant="h4" component="p" className={classes.title}>
                                    {'Promotional Campaigns'}
                                </Typography>
                                <CheckboxAll 
                                    options={promotionalData} 
                                    setOptions={setPromotionalData} 
                                    title="All Promotional Campaigns"
                                    allOptions={allPromotionalCampaigns}
                                    setAllOptions={setAllPromotionalCampaigns}
                                    id="allPromotionalCampaigns"
                                />
                            </div>
                            <div className={classes.sections}>
                                <Typography variant="h4" component="p" className={classes.title}>
                                    {'Transactional Campaigns'}
                                </Typography>
                                <CheckboxAll 
                                    options={transactionalData}
                                    setOptions={setTransactionalData} 
                                    title="All Transactional Campaigns"
                                    allOptions={allTransactionalCampaigns}
                                    setAllOptions={setAllTransactionalCampaigns}
                                    id="allTransactionalCampaigns"
                                />
                            </div>
                        </div>
                    )} 
                </CardContent>
                <Divider />
                <CardActions className={classes.cardActions}>
                    <div className={classes.submitButton}>
                        <Button
                            className={classes.button}
                            onClick={() => submitPreference()}
                            disabled={isLoading}
                            variant="contained"
                            color="primary">
                            Submit
                        </Button>
                    </div>
                </CardActions>
            </Card>
            {
                <UserMessageSnackbar
                    openSnackbar={isResubscribeSaved === 'success'}
                    message={'Resubscribed Successfully'}
                    severity={'success'}>
                </UserMessageSnackbar>
            }
            {
                <UserMessageSnackbar
                    openSnackbar={isResubscribeSaved === 'failure'}
                    message={'Failed to Resubscribe'}
                    severity={'error'}>
                </UserMessageSnackbar>
            }
        </div>
    );
}

export default Edit;